import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import './BuildingContent.scss';
import { Input } from 'reactstrap';

import { setBuildingContent } from '../../actions';

import {  
  HeaderSection,  
  Card,
} from '../../helpers';

class BuildingContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'buildingLogoURL': '',
      'welcomeVoiceURL': '',
      'thCarPaymentNote' : '',
      'thMotorcyclePaymentNote' : '',
      'thCarParkingNote': '',
      'thMotorcycleParkingNote': '',
      'thCarTenantMemberParkingNote': '',
      'thMotorcycleTenantMemberParkingNote': '',
      'enCarPaymentNote' : '',
      'enMotorcyclePaymentNote' : '',
      'enCarParkingNote': '',
      'enMotorcycleParkingNote': '',
      'enCarTenantMemberParkingNote': '',
      'enMotorcycleTenantMemberParkingNote': '',
    };
  }

  componentDidMount() {
    this.dataFillInput();
  }

    dataFillInput = () => {
      const { buildingContent } = this.props;

      if (buildingContent != null) {
        const th = buildingContent.buildingContentTH;
        const en = buildingContent.buildingContentEN;
        this.setState({
          'buildingLogoURL': th.buildingLogoURL,
          'welcomeVoiceURL': th.welcomeVoiceURL,
          'thCarPaymentNote' : th.carPaymentNote,
          'thMotorcyclePaymentNote' : th.motorcyclePaymentNote,
          'thCarParkingNote': th.carParkingNote,
          'thMotorcycleParkingNote': th.motorcycleParkingNote,
          'thCarTenantMemberParkingNote': th.carTenantMemberParkingNote,
          'thMotorcycleTenantMemberParkingNote': th.motorcycleTenantMemberParkingNote,
          'enCarPaymentNote' : en.carPaymentNote,
          'enMotorcyclePaymentNote' : en.motorcyclePaymentNote,
          'enCarParkingNote': en.carParkingNote,
          'enMotorcycleParkingNote': en.motorcycleParkingNote,
          'enCarTenantMemberParkingNote': en.carTenantMemberParkingNote,
          'enMotorcycleTenantMemberParkingNote': en.motorcycleTenantMemberParkingNote,
        });
      }
    }

    handleIsCanSave = () => Object.values(this.state).every(
      (value) => value !== null && value !== undefined && value !== '',
    )
 
    handleDispatchData = () => {
      const {
        buildingLogoURL,
        welcomeVoiceURL,
        thCarPaymentNote,
        thMotorcyclePaymentNote,
        thCarParkingNote,
        thMotorcycleParkingNote,
        thCarTenantMemberParkingNote,
        thMotorcycleTenantMemberParkingNote,
        enCarPaymentNote,
        enMotorcyclePaymentNote,
        enCarParkingNote,
        enMotorcycleParkingNote,
        enCarTenantMemberParkingNote,
        enMotorcycleTenantMemberParkingNote,
      } = this.state;

      this.props.dispatch(
        setBuildingContent({
          'buildingContentTH': {
            'buildingLogoURL': buildingLogoURL,
            'carPaymentNote': thCarPaymentNote,
            'carParkingNote': thCarParkingNote,
            'carTenantMemberParkingNote': thCarTenantMemberParkingNote,
            'motorcyclePaymentNote': thMotorcyclePaymentNote,
            'motorcycleParkingNote': thMotorcycleParkingNote,
            'motorcycleTenantMemberParkingNote': thMotorcycleTenantMemberParkingNote,
            'welcomeVoiceURL': welcomeVoiceURL,
          },
          'buildingContentEN': {
            'buildingLogoURL': buildingLogoURL,
            'carPaymentNote': enCarPaymentNote,
            'carParkingNote': enCarParkingNote,
            'carTenantMemberParkingNote': enCarTenantMemberParkingNote,
            'motorcyclePaymentNote': enMotorcyclePaymentNote,
            'motorcycleParkingNote': enMotorcycleParkingNote,
            'motorcycleTenantMemberParkingNote': enMotorcycleTenantMemberParkingNote,
            'welcomeVoiceURL': welcomeVoiceURL,
          },
          'isCanSave' : this.handleIsCanSave(),  
        }),
      );
    }

    handleEvent = (key, value) => {
      this.setState({ [key]: value }, () => this.handleDispatchData());
    }

    handleBuildingContentSection = (languageType) => (
      <Card>
        <HeaderSection title={`${languageType === 'th' ? 'Thai' : 'English'} language content`} />
        <div className="first-row">
          <div className="car-payment-note-container">
            <div className="car-payment-note-label">
             Payment note for car
            </div>
            <div className="car-payment-note-input" >
              <Input
                id={`${languageType}-car-payment-note-input`}
                className={'template-j'}                         
                placeholder="Input payment note for car"
                type="textarea"
                value={this.state[`${languageType}CarPaymentNote`]}
                onChange={(event) => {
                  const value = event.target.value;                  
                  this.handleEvent(`${languageType}CarPaymentNote`, value);
                }}
              />
            </div>
          </div>
          <div className="motorcycle-payment-note-container">
            <div className="motorcycle-payment-note-label">
             Payment note for motorcycle
            </div>
            <div className="motorcycle-payment-note-input" >
              <Input
                id={`${languageType}-motorcycle-payment-note-input`}
                className={'template-j'}                         
                placeholder="Input payment note for motorcycle"
                type="textarea"
                value={this.state[`${languageType}MotorcyclePaymentNote`]}
                onChange={(event) => {
                  const value = event.target.value;                  
                  this.handleEvent(`${languageType}MotorcyclePaymentNote`, value);
                }}
              />
            </div>
          </div>
        </div>  
        <div className="second-row">
          <div className="car-parking-note-container">
            <div className="car-parking-note-label">
             Parking note for car
            </div>
            <div className="car-parking-note-input" >
              <Input
                id={`${languageType}-car-parking-note-input`}
                className={'template-j'}                         
                placeholder="Input Parking note for car"
                type="textarea"
                value={this.state[`${languageType}CarParkingNote`]}
                onChange={(event) => {
                  const value = event.target.value;                  
                  this.handleEvent(`${languageType}CarParkingNote`, value);
                }}
              />
            </div>
          </div>
          <div className="motorcycle-parking-note-container">
            <div className="motorcycle-parking-note-label">
             Parking note for motorcycle
            </div>
            <div className="motorcycle-parking-note-input" >
              <Input
                id={`${languageType}-motorcycle-parking-note-input`}
                className={'template-j'}                         
                placeholder="Input parking note for motorcycle"
                type="textarea"
                value={this.state[`${languageType}MotorcycleParkingNote`]}
                onChange={(event) => {
                  const value = event.target.value;                  
                  this.handleEvent(`${languageType}MotorcycleParkingNote`, value);
                }}
              />
            </div>
          </div>
        </div> 
        <div className="third-row">
          <div className="car-tenant-member-parking-note-container">
            <div className="car-tenant-member-parking-note-label">
            Tenant member parking note for car
            </div>
            <div className="car-tenant-member-parking-note-input" >
              <Input
                id={`${languageType}-car-tenant-member-parking-note-input`}
                className={'template-j'}                         
                placeholder="Input tenant member parking note for car"
                type="textarea"
                value={this.state[`${languageType}CarTenantMemberParkingNote`]}
                onChange={(event) => {
                  const value = event.target.value;                  
                  this.handleEvent(`${languageType}CarTenantMemberParkingNote`, value);
                }}
              />
            </div>
          </div>
          <div className="motorcycle-tenant-member-parking-note-container">
            <div className="motorcycle-tenant-member-parking-note-label">
            Tenant member parking note for motorcycle
            </div>
            <div className="motorcycle-tenant-member-parking-note-input" >
              <Input
                id={`${languageType}-motorcycle-tenant-member-parking-note-input`}
                className={'template-j'}                         
                placeholder="Input tenant member parking note for car"
                type="textarea"
                value={this.state[`${languageType}MotorcycleTenantMemberParkingNote`]}
                onChange={(event) => {
                  const value = event.target.value;                  
                  this.handleEvent(`${languageType}MotorcycleTenantMemberParkingNote`, value);
                }}
              />
            </div>
          </div>
        </div>
    
      </Card>
    )

    render() {
      const { buildingLogoURL, welcomeVoiceURL } = this.state;
      return (
        <div className="BuildingContent">
          <div className="building-content-container">
            <Card >
              <HeaderSection title="Building material" />   
              <div className="first-row">
                <div className="building-logo-container">
                  <div className="building-logo-label">
                    Building logo URL
                  </div>
                  <div className="building-logo-input">
                    <Input
                      id={'building-logo-input'}
                      className={'template-d'}
                      placeholder="Input logo url"
                      value={buildingLogoURL}
                      onChange={(event) => {
                        const value = event.target.value;                        
                        this.handleEvent('buildingLogoURL', value);
                      }}
                    />
                  </div>
                </div>
                <div className="welcome-voice-container">
                  <div className="welcome-voice-label ">
                  Welcome voice URL
                  </div>
                  <div className="welcome-voice-input">
                    <Input
                      id={'welcome-voice-input'}
                      className={'template-d'}
                      placeholder="Input Welcome voice URL"
                      value={welcomeVoiceURL}
                      onChange={(event) => {
                        const value = event.target.value;                        
                        this.handleEvent('welcomeVoiceURL', value);
                      }}
                    />
                  </div>
                </div>
              </div>
            </Card>
          </div>
          <div className="language-content">
            {this.handleBuildingContentSection('th')}
          </div>
          <div className="language-content">
            {this.handleBuildingContentSection('en')}          
          </div>
        </div>
      );
    }
}

const mapStateToProps = ({ buildingContent }) => ({
  'buildingContent': buildingContent.data,
});

export default connect(mapStateToProps)(BuildingContent);

BuildingContent.propTypes = {
  'dispatch' : PropTypes.func,
  'buildingContent' : PropTypes.shape({
    'buildingContentTH' : PropTypes.shape({
      'buildingLogoURL' : PropTypes.string,
      'carPaymentNote' : PropTypes.string,
      'carParkingNote' : PropTypes.string,
      'carTenantMemberParkingNote' : PropTypes.string,
      'motorcyclePaymentNote' : PropTypes.string,
      'motorcycleParkingNote' : PropTypes.string,
      'motorcycleTenantMemberParkingNote' : PropTypes.string,
      'welcomeVoiceURL' : PropTypes.string,
    }),
    'buildingContentEN' : PropTypes.shape({
      'buildingLogoURL' : PropTypes.string,
      'carPaymentNote' : PropTypes.string,
      'carParkingNote' : PropTypes.string,
      'carTenantMemberParkingNote' : PropTypes.string,
      'motorcyclePaymentNote' : PropTypes.string,
      'motorcycleParkingNote' : PropTypes.string,
      'motorcycleTenantMemberParkingNote' : PropTypes.string,
      'welcomeVoiceURL' : PropTypes.string,
    }),
  }),
};
